<template>

  <div v-if="sitio !== null && menu !== null" class="white-text">
    <div class="w-100 p-3" style="min-height: 100vh">

      <div class="clearfix overflow-auto d-flex pb-2 mb-4" style="white-space: nowrap">
        <button @click="back()" class="btn btn-sm glass-btn float-start me-1">
          <IconArrowBack
              size=16
              stroke=2
          />
        </button>
        <button @click="categoria = null"
                class="btn btn-sm glass-btn float-start me-1 font-600">
          {{ i18n.todo }}
        </button>
        <button v-for="(m, index) in menu.carta_form"
                :key="index"
                @click="categoria = m.categoria.id"
                class="btn btn-sm glass-btn float-start me-1 font-600">
          {{ m.categoria.nombre }}
        </button>
      </div>

      <div v-for="(m, index) in categorias" :key="index" class="mb-5">
        <div class="font-700 font-24 mb-2 white-text">
          {{ m.categoria.nombre }}
        </div>

        <div class="p-3 mb-3 glass-card">
          <div v-for="(a, aIdx) in m.articulos" :key="a.id">
            <div class="d-flex mb-3">
              <div class="w-100 font-600 text-uppercase">
                {{ a.nombre }}
              </div>
              <div class="font-400 ps-3"
                   v-if="a.precio !== undefined && a.precio > 0"
                   style="width: fit-content; white-space: nowrap">
                {{ a.precio }} €
              </div>
            </div>

            <div class="clearfix">
              <div v-if="a.icons && a.icons.length > 0" class="float-start d-flex icons-container">
                <IconTooltip
                    class="me-1"
                    v-for="icon in a.icons"
                    :key="icon.id"
                    :height="28"
                    :src="icon.url"
                    :text="icon.nombre"
                />
              </div>

              <div v-if="a.alergenos && Object.values(a.alergenos).length > 0" class="float-end d-flex icons-container">
                <IconTooltip
                    class="me-1"
                    v-for="alergeno in Object.values(a.alergenos)"
                    :key="alergeno.id"
                    :height="28"
                    :src="alergeno.icono_url"
                    :text="alergeno.nombre"
                />
              </div>
            </div>
            <hr v-if="aIdx < m.articulos.length - 1"/>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="d-flex justify-content-center align-items-center h-100">
    <IconLoader2 size=48 class="azul-seth" />
  </div>

</template>

<script>

import IconTooltip from "@/components/IconTooltip";
import IconArrowBack from "@/partials/Icons/IconArrowBack";
import IconLoader2 from "@/partials/Icons/IconLoader2";
import {getI18n} from "@/locales/locales";

export default {

  name: 'MenuView',

  components: {IconArrowBack, IconTooltip, IconLoader2},

  data() {
    return {
      categoria: null
    };
  },

  computed: {
    sitio() {
      return this.$store.getters['sitio/sitio'];
    },
    menu() {
      return this.$store.getters['sitio/menu'];
    },
    categorias() {
      if (!this.menu) return [];
      const menus = this.categoria !== null
          ? this.menu.carta_form.filter((m) => this.categoria === m.categoria.id)
          : this.menu.carta_form;
      return menus.map(m => ({
        ...m,
        articulos: m.articulos.filter(a => a.nombre !== undefined)
      }));
    },
    i18n() {
      return getI18n();
    },
  },

  methods: {
    back() {
      history.back();
    }
  },

  created() {
    this.$store.dispatch('sitio/fetchMenu', this.$route.params.id);
  }

}
</script>
